export const ACCOUNT_MNEMONIC_WORD_COUNT = 12;
export const ACCOUNT_UPDATE_TIME = 10000;

export const GODWALLET_MNEMONIC = '//Alice';
export const GODWALLET_ACCOUNT_NAME = 'GOD';

export const ACCOUNT_NATIVE_TOKEN_ADDRESS = 'native';
